import * as types from './mutation-types'

export default{
    [types.SET_DELIVERYNOTES](state,data){
        state.deliveryNotes=data
    },
    [types.SET_TOTAL_DELIVERYNOTES](state, data){
        state.totalDeliveryNotes=data
    },
    [types.SET_PO_ITEM](state, data) {
        state.POItems = data
    },
    [types.DELETE_PO_ITEM](state, data) {
        let index = state.POItems.findIndex(POItem => POItem.systemItemId === data.systemItemId)
        state.POItems.splice(index, 1)
    },

    [types.SET_SELECT_ALL_STATE](state, data) {
        state.selectAllField = data
    },
    [types.SET_SELECTED_DELIVERYNOTES](state, data) {
        state.selectedDeliveryNotes = data
    },
    [types.RESET_SELECTED_DELIVERYNOTES](state, data) {
        state.selectedDeliveryNotes = []
        state.selectAllField = false
    },
    [types.SET_TEMPLATE_ID](state, templateId) {
        state.deliveryNoteTemplateId = templateId
    },
    [types.SELECT_CUSTOMER](state, data) {
        state.selectedCustomer = data
    },
    [types.RESET_SELECTED_CUSTOMER](state, data) {
        state.selectedCustomer = null
    },
    [types.ADD_DELIVERY_NOTE_ITEMS](state, data) {
        state.deliveryNoteItems.push(data)
        console.log('add data')
        console.log(data)
        console.log('deliveryNoteItems data')
        console.log(state.deliveryNoteItems)
    },
    [types.UPDATE_DELIVERY_NOTE_ITEM](state, data) {
        console.log('update data')
        console.log(data)
        console.log('deliveryNoteItems data')
        console.log(state.deliveryNoteItems)
        // let item = state.deliveryNoteItems.findIndex(item => item.id === data.id)
        // console.log(item)
        // if (item){
        //     state.deliveryNoteItems[item] = data
        //     //Object.assign(state.deliveryNoteItems[item.index], {...data})
        // }
        if (state.POHasItems== true){
            if (data.systemItemId !=null){
                console.log('data.systemItemId !=null')
                state.deliveryNoteItems.forEach((element, index) => {
                    console.log(element.systemItemId)
                    console.log(data.systemItemId)
                    if (element.systemItemId === data.systemItemId) {
                        console.log(state.deliveryNoteItems[index])
                        state.deliveryNoteItems[index] = data;
                    }
                    else if (element.id === data.id) {
                        console.log(state.deliveryNoteItems[index])
                        state.deliveryNoteItems[index] = data;
                    }
                });
            }else{
                state.deliveryNoteItems.forEach((element, index) => {
                    console.log('data.systemItemId else !=null')
                    if (element.id === data.id) {
                        console.log(state.deliveryNoteItems[index])
                        state.deliveryNoteItems[index] = data;
                    }
                });
            }

        } else if(state.POHasItems ==false){
            console.log('po has no items')

            if (data.systemItemId != null) {
                console.log('data.systemItemId !=null')
                state.deliveryNoteItems.forEach((element, index) => {
                    console.log(element.systemItemId)
                    console.log(data.systemItemId)
                    if (element.systemItemId === data.systemItemId) {
                        console.log(state.deliveryNoteItems[index])
                        state.deliveryNoteItems[index] = data;
                    }
                    else if (element.id === data.id) {
                        console.log(state.deliveryNoteItems[index])
                        state.deliveryNoteItems[index] = data;
                    }
                });
            } else {
                state.deliveryNoteItems.forEach((element, index) => {
                    console.log('data.systemItemId else !=null')
                    if (element.id === data.id) {
                        console.log(state.deliveryNoteItems[index])
                        state.deliveryNoteItems[index] = data;
                    }
                });
            }
        }
        console.log(state.deliveryNoteItems)
    },

    [types.DELETE_DELIVERY_NOTE](state, id) {
        let index = state.deliveryNotes.findIndex(deliveryNote => deliveryNote.id === id)
        state.deliveryNotes.splice(index, 1)
    },
    [types.DELETE_DELIVERY_NOTE_ITEM](state, item) {
        console.log('DELETE_DELIVERY_NOTE_ITEM')
        console.log(item)
        console.log(state.deliveryNoteItems)
        if (state.POHasItems == true ){

            if (state.POItems.length > 0 && item.systemItemId != null){
                console.log('state.POItems.length>0 && item.systemItemId != null')

                let removeItemIndex = state.deliveryNoteItems.findIndex(deliveryNoteItem => deliveryNoteItem.systemItemId === item.systemItemId)
                console.log("removeItemIndex" + removeItemIndex)
                if (removeItemIndex >= 0) {
                    if (item.systemItemId) {
                        let addItem = state.deliveryNoteItems.find(obj => obj.systemItemId === item.systemItemId)
                        state.POItems.push(addItem)
                    }
                    state.deliveryNoteItems.splice(removeItemIndex, 1)
                    console.log('delete deliveryNoteItems data')
                    console.log(state.deliveryNoteItems)
                } else {

                }


            }
            else if (state.POItems.length > 0 && item.systemItemId == null){
                console.log('state.POItems.length>0 && item.systemItemId == null')
                let removeItemIndex = state.deliveryNoteItems.findIndex(deliveryNoteItem => deliveryNoteItem.id === item.id)
                state.deliveryNoteItems.splice(removeItemIndex, 1)
                console.log('delete deliveryNoteItems data')
                console.log(state.deliveryNoteItems)
            }
            else if (state.POItems.length == 0 && item.systemItemId == null){
                console.log('state.POItems.length=0 && item.systemItemId == null')
                let removeItemIndex = state.deliveryNoteItems.findIndex(deliveryNoteItem => deliveryNoteItem.id === item.id)
                state.deliveryNoteItems.splice(removeItemIndex, 1)
                console.log("removeItemIndex" + removeItemIndex)
                console.log("after remove delivery Notes")
                console.log(state.deliveryNoteItems)
            }
            else if (state.POItems.length == 0 && item.systemItemId != null){
                console.log('state.POItems.length == 0 && item.systemItemId != null')
                let removeItemIndex = state.deliveryNoteItems.findIndex(deliveryNoteItem => deliveryNoteItem.systemItemId === item.systemItemId)
                console.log("removeItemIndex" + removeItemIndex)
                if (removeItemIndex >=0){
                    if (item.systemItemId) {
                        let addItem = state.deliveryNoteItems.find(obj => obj.systemItemId === item.systemItemId)
                        state.POItems.push(addItem)
                    }
                    state.deliveryNoteItems.splice(removeItemIndex, 1)
                    console.log('delete deliveryNoteItems data')
                    console.log(state.deliveryNoteItems)
                }else{

                }

            }


            // if (state.POItems.length>0 && item.systemItemId != null) {
            //     console.log('state.POItems.length>0 && item.systemItemId != null')
            //     // let removeItemIndex = state.deliveryNoteItems.findIndex(deliveryNoteItem => deliveryNoteItem.systemItemId === item.systemItemId)
            //     // if (item.systemItemId) {
            //     //     let addItem = state.deliveryNoteItems.find(obj => obj.systemItemId === item.systemItemId)
            //     //     state.POItems.push(addItem)
            //     // }
            //     // console.log("removeItemIndex" + removeItemIndex)
            //     // state.deliveryNoteItems.splice(removeItemIndex, 1)
            //     // console.log('delete deliveryNoteItems data')
            //     // console.log(state.deliveryNoteItems)
            // }
            // else if (state.POItems.length > 0 && item.systemItemId == null) {
            //     console.log('state.POItems.length>=0 && item.systemItemId != null')
            //     // let removeItemIndex = state.deliveryNoteItems.findIndex(deliveryNoteItem => deliveryNoteItem.systemItemId === item.systemItemId)
            //     // if (item.systemItemId) {
            //     //     let addItem = state.deliveryNoteItems.find(obj => obj.systemItemId === item.systemItemId)
            //     //     state.POItems.push(addItem)
            //     // }
            //     // console.log("removeItemIndex" + removeItemIndex)
            //     // state.deliveryNoteItems.splice(removeItemIndex, 1)
            //     // console.log('delete deliveryNoteItems data')
            //     // console.log(state.deliveryNoteItems)
            // }
            // else if (state.POItems==0 && item.systemItemId != null) {
            //     console.log('state.POItems==0 && item.systemItemId != null')
            //     // let removeItemIndex = state.deliveryNoteItems.findIndex(deliveryNoteItem => deliveryNoteItem.systemItemId === item.systemItemId)
            //     // if (item.systemItemId) {
            //     //     let addItem = state.deliveryNoteItems.find(obj => obj.systemItemId === item.systemItemId)
            //     //     state.POItems.push(addItem)
            //     // }
            //     // console.log("removeItemIndex" + removeItemIndex)
            //     // state.deliveryNoteItems.splice(removeItemIndex, 1)
            //     // console.log('delete deliveryNoteItems data')
            //     // console.log(state.deliveryNoteItems)
            // } else if (item.systemItemId == null) {
            //     console.log('item.systemItemId == null')
            //     // let removeItemIndex = state.deliveryNoteItems.findIndex(deliveryNoteItem => deliveryNoteItem.id === item.id)
            //     // console.log("removeItemIndex" + removeItemIndex)
            //     // state.deliveryNoteItems.splice(removeItemIndex, 1)
            //     // console.log('delete deliveryNoteItems data')
            //     // console.log(state.deliveryNoteItems)

            // }
        }
        else{
            if (item.systemItemId != null){
                console.log('item.systemItemId != null')
                let removeItemIndex = state.deliveryNoteItems.findIndex(deliveryNoteItem => deliveryNoteItem.systemItemId === item.systemItemId)
                console.log(removeItemIndex)
                state.deliveryNoteItems.splice(removeItemIndex, 1)
            }
            else{
                console.log('item.systemItemId != null else')
                let removeItemIndex = state.deliveryNoteItems.findIndex(deliveryNoteItem => deliveryNoteItem.id === item.id)
                console.log(removeItemIndex)
                state.deliveryNoteItems.splice(removeItemIndex, 1)
            }
        }
    },
    [types.DELETE_DELIVERY_NOTE_MULTIPLE_ITEMS](state, selectedDeliveryNoteItems) {
        console.log('types.DELETE_DELIVERY_NOTE_MULTIPLE_ITEMS')
        console.log(selectedDeliveryNoteItems)
        selectedDeliveryNoteItems.forEach((item) => {
            let index = state.deliveryNoteItems.findIndex(_item => _item.systemItemId === item)

            if (state.POItems.length >=0){
                let addItem = state.deliveryNoteItems.find(obj => obj.systemItemId === item)
                if (addItem.systemItemId){
                    state.POItems.push(addItem)
                }
            }

            state.deliveryNoteItems.splice(index, 1)
        })

        state.selectedDeliveryNoteItems = []
    },
    [types.SET_DELIVERYNOTE_ITEMS](state, data) {
        state.deliveryNoteItems = data
    },
    [types.SET_SELECT_ALL_STATE_ITEM](state, data) {
        state.selectAllFieldItem = data
    },
    [types.SET_SELECTED_DELIVERYNOTE_ITEMS](state, data) {
        state.selectedDeliveryNoteItems = data
    },
    [types.RESET_SELECTED_DELIVERYNOTE_ITEMS](state, data) {
        state.selectedDeliveryNoteItems = []
        state.selectAllFieldItem = false
    },
    [types.AVAILABLE_DELIVERYNOTE_ITEMS](state, data) {
        state.availableDeliveryNoteItems = data
    },
    [types.TEMP_MULTIPLE_DELETE_ITEMS](state, items) {
        items.forEach((item) => {
            let index = state.availableDeliveryNoteItems.findIndex(_item => _item.id === item.id)
            state.availableDeliveryNoteItems.splice(index, 1)
        })
    },
    [types.TEMP_DELETE_ITEM](state, data) {
        console.log(data)
        console.log(state.availableDeliveryNoteItems)
        if (data.id){
            let index = state.availableDeliveryNoteItems.findIndex(obj => obj.id === data.id)
            if (index != undefined && index>-1) {
                console.log('start index')
                console.log(index)
                console.log('end index')
                state.availableDeliveryNoteItems.splice(index, 1)
                console.log(state.availableDeliveryNoteItems)
            }
        }

        if (data.item_id) {
            let index1 = state.availableDeliveryNoteItems.findIndex(obj => obj.id === data.item_id)
            if (index1 != undefined && index1 > -1) {
                console.log('item start')
                console.log(index1)
                console.log('item end')
                state.availableDeliveryNoteItems.splice(index1, 1)
            }
        }

    },
    [types.TEMP_ADD_ITEM](state, data) {
        if (data.original_item_id && data.name){
            data.index =null
            data.id = data.original_item_id
            delete data.item_id
            data.item_id= null
            console.log('add data')
            console.log(data)
            state.availableDeliveryNoteItems.push(data)
            console.log(state.availableDeliveryNoteItems)
        }
    },
    [types.SET_DELIVERYNOTE_ITEMS_STATUS](state, data) {
        state.deliveryNoteItemsStatus = data
    },
    [types.PO_HAS_ITEM](state, data) {
        state.POHasItems = data
    },

}
